module.exports = __webpack_public_path__ + "static/media/6.9ec3eb06.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/pants/6.png
// module id = 1434
// module chunks = 0